'use strict';

var React = require('react');
var withStyles = require('../../node_modules/@material-ui/core/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    selected: {
      backgroundColor: "#BBDEFB",
      color: "#0D47A1",
      padding: "9px 0",
      borderRadius: "50%"
    },
    current: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      padding: "9px 0",
      borderRadius: "50%"
    }
  };
};

var DayPickerDay = function DayPickerDay(_ref) {
  var day = _ref.day,
      current = _ref.current,
      selected = _ref.selected,
      classes = _ref.classes;
  return React__default["default"].createElement("div", {
    className: current ? classes.current : selected ? classes.selected : null
  }, day);
};

var DayPickerDay$1 = withStyles(styles)(DayPickerDay);

module.exports = DayPickerDay$1;
